import bulkEdit from './bulkEdit'

window.DatoCmsPlugin.init(plugin => bulkEdit(plugin, document, window))
